<template>
  <div>
    <div class="marquees-wrapper news hidden md:block pt-4 md:pt-10 lg:pt-12" :class="{ 'first-open': firstVisit, 'fade': searching }">
      <div class="md:pt-0 marquees md:flex items-center justify-between uppercase md:p-10 pb-0 md:pb-0 lg:px-12 text-3xl md:text-4xl lg:text-5xl">
        <router-link :to="localeLink('/news')" class="marquee w-full mb-10 md:mb-0 border border-black text-center flex items-center justify-center md:h-32">
          <base-slider type="news" />
        </router-link>
      </div>
    </div>

    <div class="mr-header pt-20 md:pt-0">
      <div class="p-4 pb-4 md:p-10 lg:p-12">
        <div v-if="first" class="relative">
          <!-- First Feature -->
          <router-link :to="localeLink(firstLink)">
            <div class="relative" v-if="first.media">
              <img class="lazyload w-full" :key="first.media.src" :src="blank" :data-src="getImage(first.media)" v-if="first.media.type == 'image'" />
              <video :src="first.media.src" width="100%" height="500" controls autoplay v-if="first.media.type == 'video'"></video>
            </div>
            <div v-else style="font-size: 8vw">
              <span v-html="first.title" />
            </div>
            <h4 class="mt-3 text-2xl uppercase leading-tight truncate">
              <base-time-text :item="first" class="text-orange-brand"/>
              <!-- TODO: Why is this description, not title, check endpoint -->
              <span v-html="first.description" />
            </h4>
            <div class="mb-1 text-2xl uppercase leading-tight">
              <base-dates :item="first"/>
            </div>
            <p class="serif song text-xs uppercase">{{ types(first) }}</p>
          </router-link>
        </div>
      </div>
    </div>

    <!-- what's on table -->
    <now-block id="whats-on" v-if="current.length" />

    <div class="marquees-wrapper mr-header py-12 md:pt-20 md:pb-20 mb-12 md:py-0">
      <div class="block md:hidden marquees md:flex items-center justify-between uppercase md:p-10 pb-0 md:pb-0 lg:px-12 text-3xl md:text-4xl lg:text-5xl">
        <router-link :to="localeLink('/news')" class="marquee w-full mb-6 md:mb-0 border border-black border-r-0 text-center flex items-center justify-center md:h-32">
          <base-slider type="news" />
        </router-link>
      </div>
      <div class="md:pt-0 marquees md:flex items-center justify-between uppercase md:p-10 pb-0 md:pb-0 lg:px-12 text-3xl md:text-4xl lg:text-5xl">
        <router-link :to="localeLink('/books')" class="marquee w-full mb-6 md:mb-0 border border-r-0 border-black text-center flex items-center justify-center md:h-32">
          <base-slider :string="$t('slider', 'books')" separator="📚" />
        </router-link>
        <router-link :to="localeLink('/support-us')" class="marquee w-full mb-6 md:mb-0 border border-r-0 border-black text-center flex items-center justify-center md:h-32">
          <base-slider :string="$t('slider', 'supportUs')" separator="👍" />
        </router-link>
        <a href="https://shop44438753.youzan.com/v2/showcase/homepage?alias=r7mAg5aRj9" target="_blank" class="marquee w-full mb-6 md:mb-0 border-r-0 md:border-r border border-black text-center flex items-center justify-center md:h-32">
          <base-slider :string="$t('slider', 'store')" separator="🛍" />
        </a>
      </div>
    </div>

    <div v-if="others" class="lg-mr-header">
      <div v-for="(item, count) in others" class="p-4 md:p-10 lg:px-12" :key="count">
        <div class="relative mb-12">
          <!-- Remaining Features -->
          <app-link :to="getLink(item)">
            <img v-if="item.media" class="lazyload w-full" :key="item.media.src" :src="blank" :data-src="getImage(item.media)" />
            <div v-else style="font-size: 8vw">
              <span v-html="item.title" />
            </div>
            <h4 class="mt-3 text-2xl uppercase leading-tight truncate">
              <base-time-text :item="item" class="text-orange-brand"/>
              <!-- TODO: Why is this description, not title, check endpoint -->
              <span v-html="item.description" />
            </h4>
            <div class="mb-1 text-2xl uppercase leading-tight flex">
              <base-dates :item="item"/>
            </div>
            <p v-if="types(item)" class="serif song text-xs uppercase">{{ types(item) }}</p>
          </app-link>
        </div>
      </div>
  </div>
  </div>
</template>

<script>
import store from '@/store'
import NowBlock from '@/components/NowBlock'
import AppLink from '@/components/AppLink'
import { mdImg } from '@/utils'
import bus from '@/bus'

export default {
  name: 'Home',
  data () {
    return {
      blank: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
      searching: false
    }
  },
  computed: {
    featured () {
      return this.localeList(store.state.featured)
    },
    first () {
      return this.featured[0]
    },
    others () {
      return this.featured.slice(1)
    },
    firstLink () {
      return this.first && '/' + this.first.link_internal
    },
    currentTime () {
      return new Date()
    },
    current () {
      return this.localeList(store.state.current)
    },
    firstVisit () {
      return this.$store.state.firstVisit
    },
    firstVisitSide () {
      return {
        marginRight: (this.firstVisit && window.innerWidth >= 1280) ? '300px' : 0
      }
    }
  },
  mounted () {
    bus.$on('searching', (x) => {
      this.searching = x
    })
  },
  methods: {
    mdImg,
    now ({ start, end }) {
      const startDate = new Date(start)
      const endDate = new Date(end)
      return startDate < this.currentTime && this.currentTime < endDate
    },
    types (item) {
      if (!item || !item.types) return
      return item.types.map(t => t.title).join(', ')
    },
    assemblies (item) {
      if (!item || !item.assemblies) return
      return item.assemblies.map(a => a.title).join(', ')
    },
    getImage (img) {
      if (!img.sizes) return this.mdImg(img)
      const w = window.innerWidth

      // return scaled size
      const s = w > 1400 ? 'xl' : w > 800 ? 'lg' : 'md'

      return img.sizes[s].src
    },
    getLink (item) {
      if (item.link_type === 'internal') {
        return this.localeLink(item && '/' + item.link_internal)
      } else {
        return item.link_external
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!from.name) {
      // first load, show menu
      store.commit('FIRST_VISIT')
    }
    Promise.all([
      store.dispatch('getFeatured'),
      store.dispatch('getCurrent'),
      store.dispatch('getNews')
    ]).then(next)
  },
  components: { NowBlock, AppLink }
}
</script>
